<template>
  <BaseRetentionModal
    :title="translations.title"
    :subtitle="translations.description"
    hookSufix="AddCustomPitchModal"
    :helpArticle="helpArticle"
    @ok="handleAddRetention"
    :loading="loading"
    :showNameInput="true"
  />
</template>

<script>
import BaseRetentionModal from './BaseRetentionModal.vue'
import playerApi from '@/services/playerApi'
import { mapMutations } from 'vuex'

export default {
  name: 'AddCustomPitchModal',
  data() {
    return {
      loading: false,
    }
  },
  components: {
    BaseRetentionModal,
  },
  computed: {
    translations() {
      return {
        title: this.$i18next.t(
          'message.pages.analyticsV3.retentionv3.pitches.custom.title'
        ),
        description: this.$i18next.t(
          'message.pages.analyticsV3.retentionv3.pitches.custom.description'
        ),
      }
    },
    helpArticle() {
      const urls = {
        en: '',
        pt: '',
        es: '',
      }
      return urls[this.$i18next.resolvedLanguage] || urls.pt
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async handleAddRetention(data) {
      try {
        this.loading = true
        const newVideoRetentionMarkers =
          data.video.video.retention_markers.filter(
            (marker) => marker.type !== 'custom'
          )
        await playerApi.updateVideoRetentionMarkers(data.video_id, [
          ...newVideoRetentionMarkers,
          {
            time: data.time,
            type: 'custom',
            title: data.title,
          },
        ])
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t(
            'message.pages.analyticsV3.retentionv3.pitches.feedback.custom.success'
          ),
          type: 'success',
        })
        this.$root.$emit('closeAddCustomPitchModal', data)
        this.$root.$emit('closeAddCustomPitchModalData', data)
      } catch (err) {
        console.error(err)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text:
            err?.response?.data?.message ||
            this.$t('message.errors.unexpectedError'),
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
